module.exports = __webpack_public_path__ + "static/btnTip2.900c2ec4.png";